// FILE: chatgptApi.js
import axios from 'axios';

const API_URL = 'https://api.openai.com/v1/chat/completions';

export const askChatGPT = async (userInput) => {
  try {
    console.log('All Environment Variables:', process.env); // Print all environment variables
    const API_KEY = process.env.REACT_APP_OPENAI_KEY; // Use environment variable injected at runtime
    console.log('Loaded API Key:', API_KEY); // Debug log for API key
    if (!API_KEY) {
      console.error('REACT_APP_OPENAI_KEY is not defined. Please check your Heroku Config Vars.');
      return 'API key is missing.';
    }

    const response = await axios.post(
      API_URL,
      {
        model: "gpt-4",  // Use "gpt-3.5-turbo" for a cheaper option
        messages: [
          { role: "system", content: "You are a helpful assistant." },
          { role: "user", content: userInput }
        ],
        max_tokens: 150,
      },
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${API_KEY}`,
        },
      }
    );

    console.log('Received response from ChatGPT API:', response.data); // Log API response
    return response.data.choices[0].message.content.trim();
  } catch (error) {
    console.error('Error calling ChatGPT API:', error?.response?.data || error.message); // Log error details
    return 'Sorry, something went wrong.';
  }
};
